import { Link } from 'react-router-dom'
import { cn } from '@/lib/cn'

type CtaVariant = 'primary' | 'secondary'
type CtaSize = 'md' | 'sm'

/**
 * Shared pill-style CTA link for Kaamco's public marketing pages.
 * Consolidates the button that was previously duplicated across
 * LandingPage, PricingPage, and PublicSiteLayout.
 */
export function CtaLink({
  to,
  children,
  variant = 'primary',
  size = 'md',
  className,
}: {
  to: string
  children: React.ReactNode
  variant?: CtaVariant
  size?: CtaSize
  className?: string
}): React.ReactElement {
  return (
    <Link
      to={to}
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        size === 'md' ? 'min-h-12 px-6 py-3 text-sm' : 'min-h-11 px-5 py-2.5 text-sm',
        variant === 'primary'
          ? 'bg-[var(--public-cta)] text-white shadow-[0_20px_45px_rgba(11,35,64,0.22)] focus-visible:ring-[var(--public-cta)]'
          : 'border border-[var(--public-border-strong)] bg-white text-[var(--public-ink)] focus-visible:ring-[var(--public-accent)]',
        className
      )}
    >
      {children}
    </Link>
  )
}
